import { Button, LabeledRightIconInput } from '@apex/component-library'
import { Icon, Wrap, WrapItem } from '@chakra-ui/react'
import React, { FormEvent, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { FaSearch } from 'react-icons/fa'
import { useAccountSearch } from '../../hooks'
import {
  NOT_LETTER_OR_NUMBER,
  removeSpecialCharacters,
  trimSpacesAndDashes,
  useFormatMessage,
} from '../../utils'
import { startsWith } from 'lodash'

const MIN_SEARCH_LENGTH = 3

const AccountSearchBar = () => {
  const {
    accountSearchState: { loadingResults, searchTerm = '' },
    searchAccounts,
  } = useAccountSearch()
  const formatMessage = useFormatMessage()
  const history = useHistory()
  const [search, setSearch] = useState<string>(() => {
    const locationSearch = startsWith(history.location.search, '?q=')
      ? decodeURIComponent(history.location.search.substring('?q='.length))
      : ''
    return locationSearch || searchTerm
  })

  const handleSubmit = (e: FormEvent) => {
    searchAccounts(trimSpacesAndDashes(search), history)
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <form onSubmit={handleSubmit}>
      <Wrap
        backgroundColor="apex.whiteSmoke"
        borderBottomColor="apex.darkGray"
        borderBottomWidth={1}
        align="flex-end"
        spacing="1rem"
        padding="1rem"
      >
        <WrapItem>
          <LabeledRightIconInput
            fontWeight="bold"
            size="md"
            width="16rem"
            label={formatMessage('accounts.search.label')}
            icon={<Icon as={FaSearch} />}
            placeholder={formatMessage('accounts.search.placeholder')}
            value={search}
            aria-label="search"
            onChange={e => setSearch(removeSpecialCharacters(e.target.value))}
            isRequired
          />
        </WrapItem>
        <WrapItem>
          <Button
            variant="primary"
            type="submit"
            disabled={
              search.replace(NOT_LETTER_OR_NUMBER, '').length <
              MIN_SEARCH_LENGTH
            }
            isLoading={loadingResults}
          >
            {formatMessage('accounts.search')}
          </Button>
        </WrapItem>
        <WrapItem>
          <Button
            variant="link"
            border={0}
            color="apex.cornflowerBlue"
            px={5}
            onClick={() => setSearch('')}
          >
            Clear
          </Button>
        </WrapItem>
      </Wrap>
    </form>
  )
}

export default AccountSearchBar
